import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BankIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Bank",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.12 27.13h23.75c.53 0 .96.43.96.96v.95c0 .53-.43.96-.96.96H4.12a.96.96 0 0 1-.96-.96v-.95c0-.53.43-.96.96-.96m.87-14.76h22.03c.65 0 1.16-.53 1.16-1.18 0-.3-.12-.59-.33-.81L16.77 2.35a1.15 1.15 0 0 0-1.62-.02l-.02.02-10.97 8.04c-.45.45-.45 1.19 0 1.64.22.22.51.34.82.34Zm4.87 1.29H8.17a.67.67 0 0 0-.68.66v9.24H5.8c-.41 0-.74.32-.74.72V25c0 .41.33.74.74.74h20.39c.41 0 .74-.33.74-.74v-.71c0-.41-.33-.73-.73-.73h-1.7v-9.19a.67.67 0 0 0-.66-.68H22.2a.67.67 0 0 0-.68.66v9.24h-4v-9.22a.67.67 0 0 0-.66-.68h-1.7a.67.67 0 0 0-.68.66v9.24h-3.95v-9.22a.67.67 0 0 0-.63-.71z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M1.29 10.79h29.42c.52 0 .97-.35 1.11-.85.13-.5-.08-1.03-.53-1.29L16.57.16c-.35-.2-.79-.2-1.14 0L.72 8.65c-.45.26-.67.79-.53 1.29s.59.85 1.11.85ZM16 2.47l10.44 6.02H5.56zM5.81 12.73c-.63 0-1.15.51-1.15 1.15v11.31H3.54c-.63 0-1.15.51-1.15 1.14s.51 1.14 1.15 1.14h24.9a1.14 1.14 0 1 0 0-2.28h-1.12V13.88c0-.63-.51-1.15-1.14-1.15s-1.14.51-1.14 1.15v11.31h-4.5V13.88c0-.63-.51-1.15-1.14-1.15s-1.14.51-1.14 1.15v11.31h-4.51V13.88a1.15 1.15 0 0 0-2.3 0v11.31h-4.5V13.88c0-.63-.51-1.15-1.15-1.15ZM30.71 29.72H1.29c-.63 0-1.15.51-1.15 1.14S.65 32 1.29 32h29.42a1.14 1.14 0 1 0 0-2.28"
      })
    })
  }));
};
BankIcon.displayName = 'BankIcon';